import { SsoType } from '@diritto/common/account/constants/sso.constant';
import { useCallback } from 'react';
import { useClient } from 'ui-hooks/useClient';

export const useSignAppNative = () => {
  const client = useClient();

  return useCallback(
    (ssoType: SsoType) => {
      if (!client.isApp) {
        return false;
      }

      // iOS - Apple 은 앱에서 처리한다. Android - Apple 은 웹에서 처리한다.
      if (ssoType === SsoType.Apple) {
        return client.isIosApp;
      }

      // Ridi는 앱에서 처리한다.
      if (ssoType === SsoType.Ridi) {
        return false;
      }

      // iOS - Naver 는 앱에서 처리한다. Android - Naver 은 웹에서 처리한다.
      // 안드에서 Naver 라이브러리 오류 https://github.com/crossplatformkorea/react-native-naver-login/issues/158
      if (ssoType === SsoType.Naver) {
        return client.isIosApp;
      }

      return ssoType !== SsoType.Email;
    },
    [client],
  );
};
